(function () {
const $2e795ccd3f572721$var$HS_PORTAL_ID = "41369222";
const $2e795ccd3f572721$var$HS_FORM_GUID = "4c4da50f-dbca-4f6b-98be-7ad0655068b1";
let $2e795ccd3f572721$var$visitorIpAddress;
const $2e795ccd3f572721$var$isHumanEnough = (formData)=>formData.get("soy_un_aparato").length === 0;
const $2e795ccd3f572721$var$getVisitorIpAddress = ()=>fetch("https://api.ipify.org").then((res)=>res.text());
const $2e795ccd3f572721$var$sendFormData = (formData)=>{
    const fields = formData.entries().map(([name, value])=>({
            name: name,
            value: value
        })).toArray();
    const context = {
        ipAddress: $2e795ccd3f572721$var$visitorIpAddress,
        pageName: document.title,
        pageUri: document.URL.toString()
    };
    return fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${$2e795ccd3f572721$var$HS_PORTAL_ID}/${$2e795ccd3f572721$var$HS_FORM_GUID}`, {
        headers: {
            "Content-Type": "application/json"
        },
        method: "post",
        body: JSON.stringify({
            fields: fields,
            context: context
        })
    });
};
const $2e795ccd3f572721$var$showSuccessMessage = (form, message)=>{
    const title = document.querySelector("h1");
    const messageEl = document.createElement("div");
    messageEl.classList.add("event-form__message");
    messageEl.innerHTML = message;
    // Replace the title
    title.textContent = "Thank you";
    // Remove the other elements next to the title
    for(let el = title.nextElementSibling; el !== null; el = el.nextElementSibling)el.remove();
    // Add the message
    title.insertAdjacentElement("afterend", messageEl);
    // Remove the form
    form.remove();
};
const $2e795ccd3f572721$var$updateFormState = (form, blocked)=>{
    const submitButton = form.querySelector('button[type="submit"]');
    if (blocked) {
        form.style.pointerEvents = "none";
        submitButton.disabled = true;
        submitButton.textContent = "Sending...";
        submitButton.style.opacity = "0.75";
    } else {
        form.style.pointerEvents = "all";
        submitButton.disabled = false;
        submitButton.textContent = "Submit";
        submitButton.style.opacity = "1";
    }
};
const $2e795ccd3f572721$var$handleFormSubmit = async (event)=>{
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    if ($2e795ccd3f572721$var$isHumanEnough(formData)) {
        $2e795ccd3f572721$var$updateFormState(form, true);
        const response = await (await $2e795ccd3f572721$var$sendFormData(formData)).json();
        if (response?.inlineMessage) $2e795ccd3f572721$var$showSuccessMessage(form, response.inlineMessage);
        else $2e795ccd3f572721$var$updateFormState(form, false);
    }
};
document.querySelectorAll(".wp-block-occasions-event-form").forEach((form)=>{
    form.addEventListener("submit", $2e795ccd3f572721$var$handleFormSubmit);
});
$2e795ccd3f572721$var$getVisitorIpAddress().then((ipAddress)=>{
    $2e795ccd3f572721$var$visitorIpAddress = ipAddress;
});

})();
//# sourceMappingURL=event-form-script.js.map
